import { reactive, ref } from 'vue'
import { STEPS } from '../constants/steps.js'

export function useLoginFlow() {
  const currentStep = ref(STEPS.IDENTIFIER)
  const isLoading   = ref(false)

  const flowData = reactive({
    identifier:      '',
    identifierType:  '', // 'email' | 'phone'
    userType:        '', // 'patient' | 'practice' | 'admin'
    preferredMethod: null, // MFA_METHOD.SMS | MFA_METHOD.EMAIL | null
    hasPreferredMethod: false,
    mfaEnabled:     true,
    trustDevice:     false,
    magicLinkChannel: '',
    resetLinkChannel: '',
    passwordResetRequired: false,
    resetToken:      '',
    verifyBackStep:  '',
    flowMode:        'modern',
  })

  const navigateTo = (step) => {
    currentStep.value = step
  }

  const setFlowData = (data) => {
    Object.assign(flowData, data)
  }

  return {
    currentStep,
    isLoading,
    flowData,
    navigateTo,
    setFlowData,
  }
}
